export const ROOT_PATH = '/' as const;

export const DASHBOARD_PATH = '/dashboard' as const;

export const TEMPLATE_PATH = '/scout/templates' as const;
export const NEW_TEMPLATE_PATH = '/scout/templates/new' as const;

export const TALENT_PATH = '/talent' as const;
export const TALENT_DETAIL_PATH = '/talent/:userId' as const;

export const ENTERPRISE_PATH = '/enterprise' as const;
export const NEW_ENTERPRISE_PATH = '/enterprise/new' as const;

export const COMPANY_PATH = '/company' as const;
export const COMPANY_REMOTE_PATH = '/company/remote' as const;
export const COMPANY_EDIT_PATH = '/company' as const;

export const ACCOUNT_PATH = '/account' as const;
export const ACCOUNT_SETTING_PATH = '/account/setting' as const;

export const SCOUT_PATH = '/scout' as const;
export const NEW_SCOUT_PATH = '/scout/new' as const;

export const MESSAGE_PATH = '/messages' as const;
export const MESSAGE_DETAIL_PATH = '/messages/:messageId' as const;

export const PROJECT_PATH = '/projects' as const;
export const NEW_PROJECT_PATH = '/projects/new' as const;
export const PROJECT_DETAIL_PATH = '/projects/:projectId' as const;
export const PROJECT_EDIT_PATH = '/projects/:projectId/edit' as const;

export const CONTRACT_PATH = '/contracts' as const;
export const CONTRACT_DETAIL_PATH = '/contracts/:contractId' as const;

export const WORK_REPORT_PATH = '/work-reports' as const;
export const WORK_REPORT_DETAIL_PATH = '/work-reports/:reportId' as const;

export const INVOICE_PATH = '/invoices' as const;
export const INVOICE_DETAIL_PATH = '/invoices/:invoiceId' as const;

export const SETTING_PATH = '/setting' as const;

export const LOGIN_PATH = '/login' as const;

export const SIGN_UP_PATH = '/signup' as const;

export const PASSWORD_RESET_PATH = '/password-reset' as const;
export const PASSWORD_RESET_VERIFY_PATH = '/password-reset/verify' as const;

export const MAINTENANCE_PATH = '/maintenance' as const;
export const SERVER_ERROR_PATH = '/server-error' as const;
export const NOT_FOUND_PATH = '*' as const;

export const TALENT_LIST_TABS = [
  {
    label: '候補者検索',
    param: 'search',
  },
  {
    label: 'オファー検討中リスト',
    param: 'pending-offers',
  },
  {
    label: '契約済みリスト',
    param: 'contract-list',
  },
];

export const TALENT_DETAIL_TABS = [
  {
    label: 'スキルセット・経歴',
    param: 'skill',
  },
  {
    label: '希望条件',
    param: 'conditions',
  },
];
